export type RelativeColorName =
  | 'pink'
  | 'red'
  | 'orange'
  | 'yellow'
  | 'lightgreen'
  | 'green'
  | 'lightblue'
  | 'blue'
  | 'purple'
  | 'violet'
  | 'gray'

export const relativeColorClasses: Record<RelativeColorName, string> = {
  pink: 'bg-[oklch(from_var(--pink)_0.9_0.05_h)] text-[oklch(from_var(--pink)_0.3_0.13_h)] dark:bg-[oklch(from_var(--pink)_0.3_0.13_h)] dark:text-[oklch(from_var(--pink)_0.9_0.05_h)]',
  red: 'bg-[oklch(from_var(--red)_0.9_0.05_h)] text-[oklch(from_var(--red)_0.3_0.135_h)] dark:bg-[oklch(from_var(--red)_0.3_0.135_h)] dark:text-[oklch(from_var(--red)_0.9_0.05_h)]',
  orange:
    'bg-[oklch(from_var(--orange)_0.9_0.05_h)] text-[oklch(from_var(--orange)_0.33_0.087_h)] dark:bg-[oklch(from_var(--orange)_0.33_0.087_h)] dark:text-[oklch(from_var(--orange)_0.9_0.05_h)]',
  yellow:
    'bg-[oklch(from_var(--yellow)_0.92_0.075_h)] text-[oklch(from_var(--yellow)_0.35_0.082_h)] dark:bg-[oklch(from_var(--yellow)_0.35_0.082_h)] dark:text-[oklch(from_var(--yellow)_0.92_0.075_h)]',
  lightgreen:
    'bg-[oklch(from_var(--lightgreen)_0.93_0.08_h)] text-[oklch(from_var(--lightgreen)_0.35_0.08_h)] dark:bg-[oklch(from_var(--lightgreen)_0.35_0.08_h)] dark:text-[oklch(from_var(--lightgreen)_0.93_0.08_h)]',
  green:
    'bg-[oklch(from_var(--green)_0.9_0.05_h)] text-[oklch(from_var(--green)_0.3_0.127_h)] dark:bg-[oklch(from_var(--green)_0.3_0.127_h)] dark:text-[oklch(from_var(--green)_0.9_0.05_h)]',
  lightblue:
    'bg-[oklch(from_var(--lightblue)_0.92_0.05_h)] text-[oklch(from_var(--lightblue)_0.35_0.078_h)] dark:bg-[oklch(from_var(--lightblue)_0.35_0.078_h)] dark:text-[oklch(from_var(--lightblue)_0.92_0.05_h)]',
  blue: 'bg-[oklch(from_var(--blue)_0.9_0.05_h)] text-[oklch(from_var(--blue)_0.3_0.203_h)] dark:bg-[oklch(from_var(--blue)_0.3_0.203_h)] dark:text-[oklch(from_var(--blue)_0.9_0.05_h)]',
  purple:
    'bg-[oklch(from_var(--purple)_0.9_0.05_h)] text-[oklch(from_var(--purple)_0.32_0.183_h)] dark:bg-[oklch(from_var(--purple)_0.32_0.183_h)] dark:text-[oklch(from_var(--purple)_0.9_0.05_h)]',
  violet:
    'bg-[oklch(from_var(--violet)_0.9_0.05_h)] text-[oklch(from_var(--violet)_0.3_0.15_h)] dark:bg-[oklch(from_var(--violet)_0.3_0.15_h)] dark:text-[oklch(from_var(--violet)_0.9_0.05_h)]',
  gray: 'bg-[oklch(from_var(--gray)_0.94_0_h)] text-[oklch(from_var(--gray)_0.34_0_h)] dark:bg-[oklch(from_var(--gray)_0.34_0_h)] dark:text-[oklch(from_var(--gray)_0.94_0_h)]',
}

export function relativeColorName(color: string): RelativeColorName {
  if (color === 'pink') return 'pink'
  if (color === 'red') return 'red'
  if (color === 'orange') return 'orange'
  if (color === 'yellow') return 'yellow'
  if (color === 'lightgreen') return 'lightgreen'
  if (color === 'green') return 'green'
  if (color === 'lightblue') return 'lightblue'
  if (color === 'blue') return 'blue'
  if (color === 'purple') return 'purple'
  if (color === 'violet') return 'violet'
  return 'gray'
}
